<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="商品一覧" />
    <div class="product-type" :class="this.$isPC ? '' : 'sp-product-type'">
      <section class="for-outgoing">
        <div class="product-header">
          <h3>
            <span>たくさんの人に</span><br />
            <span class="header-bold">コールしたい!!</span>
          </h3>
        </div>
        <ul class="product-items">
          <li v-for="(item, index) in outgoingItems" :key="index">
            <product-item-summary
              v-bind:name="item.name"
              v-bind:imagePath="item.imagePath"
              v-bind:appeal="item.appeal"
              v-bind:detail="item.detail"
              v-bind:link="item.link"
            />
          </li>
        </ul>
      </section>

      <section class="for-incoming">
        <div class="product-header">
          <h3>
            <span>たくさんの人や設置場所から</span><br />
            <span class="header-bold">コールを受けたい!!</span>
          </h3>
        </div>
        <ul class="product-items">
          <li v-for="(item, index) in incomingItems" :key="index">
            <product-item-summary
              v-bind:name="item.name"
              v-bind:imagePath="item.imagePath"
              v-bind:appeal="item.appeal"
              v-bind:detail="item.detail"
              v-bind:link="item.link"
            />
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import ProductItemSummary from '@/components/modules/ProductItemSummary'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    HeaderBanner,
    ProductItemSummary,
    Breadcrumb,
  },
  title: '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call｜商品一覧',
  meta:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Callの商品一覧ページです。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  data() {
    return {
      outgoingItems: [
        {
          name: 'remote-reply-call',
          imagePath: '/static/products/remote-reply-call/product.png',
          appeal:
            '長距離通信を実現！32文字のメッセージで確実に知らせる！受信状況も画面で確認できる！',
          detail: `リプライコールの性能を更に強化。これまでの通信距離を大幅に拡大し、お客様が近隣にいなくても呼び出しができるようになりました。
            音・振動に加え、文字情報 (32 文字以内 ) で確実にお知らせ。大型ショッピングモールやアミューズメント施設等での呼び出しに最適です。`,
        },
        {
          name: 'remote-reply-call-pc',
          imagePath: '/static/products/remote-reply-call-pc/product.png',
          appeal:
            'リモートリプライコールをマウス / タッチパネルの簡単操作で利用することができます！',
          detail: `リモートリプライコールを PC 画面から管理できます。マウス / タッチパネルの簡単操作で受信機を呼出し、呼び出し状況もわかりやすいアイコン表示で、お知らせ漏れの心配もありません。簡単操作で誰でも安心して使いこなしていただけるシステムです。`,
        },
        {
          name: 'reply-call',
          imagePath: '/static/products/reply-call/product.png',
          appeal:
            'LED・ブザー音・バイブレーションなどでお客様をスマートにお呼び出し。トラブルもしっかり予防 !',
          detail:
            'リプライコールなら、お客様の満足度もアップ！待ち時間をもっともっと快適に過ごしていただくことができます。安心して業務が行える「受信確認機能」や「圏外お知らせ機能」、使用場所を選ばず広い敷地でも OK ！かんたん操作で、すぐに使いこなせます！',
        },
        {
          name: 'reply-call-pc',
          imagePath: '/static/products/reply-call-pc/product.png',
          appeal: `リプライコールをパソコンやタブレットから
            操作することができます。`,
          detail: `最大500台の受信機に対応!255個までの登録コードをワンタッチで受信機へ送信できるので、業務のより円滑な遂行が可能になります！
            使い慣れたマウスやタッチパネルでのカンタン操作が可能。
            従来のリプライコールを上回る高機能＆高操作性を実現しています。`,
        },
      ],
      incomingItems: [
        {
          name: 'beyond-ec',
          imagePath: '/static/products/beyond-ec/product.png',
          appeal: `お手持ちのスマホがそのままレシーバーとして利用できる
            Wi-Fi を利用した「新・呼び出しシステム」！`,
          detail: `Beyond EC は、通信無料の特定小電力無線（920MHz 帯）と、Wi-Fi（無線 LAN）を組み合わせた呼び出しシステム。Wi-Fi を使うので専用のレシーバーは不要。お手持ちの Android スマホをそのまま表示機として利用できる新しい呼び出しシステムです。`,
        },
        {
          name: 'eco-chime',
          imagePath: '/static/products/eco-chime/product.png',
          appeal: `元祖！電池レス呼び出しチャイム。
            電池交換不要でエコ＆トラブル減少を実現！`,
          detail:
            '電池を使わないエコチャイムは、従来の飲食店やご家庭、工場での使用はもちろん、手の届きにくい場所や、取り外しにくい場所など幅広い場所で使用できる新しいチャイムです。防水性能も向上して丸洗いできるので、常に清潔な衛生状態で様々な場所での利用に適しています。',
        },
        {
          name: 'coco-call',
          imagePath: '/static/products/coco-call/product.png',
          appeal: `送信機ごとにチャイム音が設定できる！
            使い勝手の良さと豊富なデザインが魅力のコココール。`,
          detail: `呼び出しを確実に伝えてくれるコードレス・チャイム・システム。
            受信表示機の表示窓に角度がついているので番号が見やすくなっています。防水構造で衝撃にも強い送信機は、豊富な機能で業務を強力にサポートします。`,
        },
        {
          name: 'fact-in-call',
          imagePath: '/static/products/fact-in-call/product.png',
          appeal: `急なトラブルや呼び出しを逃さない！
            工場、飲食店、病院などで活躍するコールシステム！`,
          detail: `少人数スタッフで効率よく対応することが可能！テーブルの上などに設置された送信機の呼び出しボタンをプッシュすれば、その信号を受信表示機がキャッチして、表示機や音でお知らせします。
            よりスピーディーな対応が可能になります！`,
        },
      ],
    }
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: '商品一覧',
            path: 'https://b-call.jp/products',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
h3 {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  display: unset;
}

.product-type {
  width: 100%;
  margin-bottom: 30px;
}

.product-type li {
  margin: 20px 0 50px;
}

.product-type li + :last-child {
  margin-bottom: 30px;
}

.sp-product-type {
  flex-direction: column;
}

.sp-product-type .for-outgoing,
.sp-product-type .for-incoming {
  margin: 0;
}

.sp-product-type .product-header {
  float: none;

  width: 100%;
  padding: 0;
}

.sp-product-type .product-items {
  float: none;

  width: auto;
  padding: 0;
}

.sp-product-type .product-item-summary {
  margin: 0 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Products.vue